import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { OrganizationLocationDto } from '../../../models/location/dto/location.dto';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { GET_LOCATION_QUERY_KEY } from './useGetLocation';

export const useUploadLocationImage = (locationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization } = useSelectedOrganization();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['uploadLocationImage', locationId],
        mutationFn: async (file: File) => {
            const formData = new FormData();
            formData.append('image', file);
            return apiClient.fetchApiWithFormData<OrganizationLocationDto>({
                endpoint: `organizations/${selectedOrganization?.id}/locations/${locationId}/image`,
                method: 'POST',
                formData,
            });
        },
        onSuccess: (response) => {
            queryClient.setQueryData<OrganizationLocationDto>(GET_LOCATION_QUERY_KEY(locationId), response);
            onSuccess();
        },
    });
};
